import React, { useState } from 'react';
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Paper,
} from '@mui/material';
import './manualOnboarding.css';
import {
  JSONContainer,
  PolicyData,
} from '../../../../../components/AccountOnboarding/ManualAccountOnboarding/JSONContainer';
import { CUSTOM_POLICIES } from '../config';
import CustomButton from '../../../../../components/MasterComponent/Button/CustomButton';

interface CreateCustomPolicyProps {
  onComplete: () => void;
}

const CreateCustomPolicy: React.FC<CreateCustomPolicyProps> = ({
  onComplete,
}) => {
  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState<{ [k: number]: boolean }>({});

  const [policies, setPolicies] = useState<PolicyData[]>(CUSTOM_POLICIES);

  const handleCopyJson = (index: number) => {
    policies[index].json &&
      navigator.clipboard.writeText(policies[index].json || 'Copied').then(
        () => {
          const updatedPolicies = [...policies];
          updatedPolicies[index].copied = true;
          setPolicies(updatedPolicies);

          // Update completion status for this step
          const newCompleted = { ...completed };
          newCompleted[index] = true;
          setCompleted(newCompleted);

          // Reset copied status after 3 seconds
          setTimeout(() => {
            const resetPolicies = [...updatedPolicies];
            resetPolicies[index].copied = false;
            setPolicies(resetPolicies);
          }, 3000);
        },
        (err) => {
          console.error('Could not copy text: ', err);
        }
      );
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const totalSteps = () => {
    return CUSTOM_POLICIES.length;
  };

  const allStepsCompleted = Object.keys(completed).length === totalSteps();

  return (
    <Box className="customPolicyContainer">
      <Paper elevation={0} className="instructionsPaper">
        <p className="instructions">
          Follow these steps to create custom policies in your AWS IAM console.
          Copy each policy JSON and create a new policy with the suggested name.
        </p>
      </Paper>

      <Stepper activeStep={activeStep} orientation="vertical">
        {CUSTOM_POLICIES.map((policy, index) => (
          <Step key={index} completed={completed[index]}>
            <StepLabel>
              <h6>{policy.name}</h6>
            </StepLabel>
            <StepContent>
              <JSONContainer
                key={index}
                index={index}
                policy={policy}
                activeStep={activeStep}
                totalSteps={totalSteps()}
                onCopyJson={handleCopyJson}
                onNext={handleNext}
                onBack={handleBack}
              />
            </StepContent>
          </Step>
        ))}
      </Stepper>
      <Box className="navigationButtons" sx={{ flexDirection: 'row-reverse' }}>
        <div className="d-flex align-center">
          {!allStepsCompleted && (
            <p className="warningMessageManualOnboarding mr-10">
              ( Please copy & paste all policy JSON files into AWS IAM before
              proceeding. )
            </p>
          )}
          <CustomButton
            buttonType="contained"
            onClickHandler={onComplete}
            disabled={!allStepsCompleted}
          >
            Next: Create Role
          </CustomButton>
        </div>
      </Box>

      {/* {isLastStep() && (
        <Paper square elevation={0} className="completionPaper">
          <Typography className="completionText">
            All policies have been copied. Click "Finish" to proceed to the next
            step.
          </Typography>
          <Button
            variant="contained"
            onClick={handleComplete}
            className="completionButton"
          >
            Finish
          </Button>
        </Paper>
      )} */}
    </Box>
  );
};

export default CreateCustomPolicy;
